<div role="dialog" aria-labelledby="changePasswordDialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="changePasswordDialog" class="modal-title">{{ 'shared.resetPasswordLib.title' | translate }}</h4>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          (click)="onClose()"
        ></button>
      </div>
      <div class="modal-body">
        <form [formGroup]="formGroup">
          <div class="row">
            <div class="col-xs-12 mb-3">
              <label class="form-label">{{ 'shared.resetPasswordLib.newPassword' | translate }}</label>
              <div class="custom-input-password">
                <input
                  [type]="!hideAllPasswords ? 'password' : 'text'"
                  formControlName="newPassword"
                  class="form-control"
                  [placeholder]="'shared.resetPasswordLib.newPassword' | translate"
                />
                <button
                  type="button"
                  (click)="hideAllPasswords = !hideAllPasswords"
                >
                  <i
                    class="mdi {{
                      hideAllPasswords ? 'mdi-eye' : 'mdi-eye-off'
                    }}"
                  >
                  </i>
                </button>
              </div>
              <field-error-component [field]="'newPassword'" [label]="'shared.resetPasswordLib.newPassword' | translate" [formGroup]="formGroup" />
            </div>
          </div>
          <div class="row">
            <div class="col-xs-12 mb-3">
              <label class="form-label">{{ 'shared.resetPasswordLib.confirmNewPassword' | translate }}</label>
              <div class="custom-input-password">
                <input
                  [type]="!hideAllPasswords ? 'password' : 'text'"
                  formControlName="confirmedNewPassword"
                  class="form-control"
                  [placeholder]="'shared.resetPasswordLib.confirmNewPassword' | translate"
                />
                <button
                  type="button"
                  (click)="hideAllPasswords = !hideAllPasswords"
                >
                  <i
                    class="mdi {{
                      hideAllPasswords ? 'mdi-eye' : 'mdi-eye-off'
                    }}"
                  >
                  </i>
                </button>
              </div>
              <field-error-component [field]="'confirmedNewPassword'" [label]="'shared.resetPasswordLib.confirmNewPassword' | translate" [formGroup]="formGroup" />
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-light" (click)="onClose()">
          {{ 'shared.resetPasswordLib.cancel' | translate }}
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          [disabled]="!formGroup.valid || loading"
          (click)="save()"
        >
          {{ !loading ? ('shared.resetPasswordLib.change' | translate) : "" }}
          @if (loading) {
            <mat-spinner
              [diameter]="25"
              [color]="'accent'"
              mode="indeterminate"
            />
          }
        </button>
      </div>
    </div>
  </div>
</div>
